/**
 * Created by hj on 2017/8/24.
 */
import React from 'react';
import { hashHistory } from 'react-router';
import { Form, Input, Button, Row, Col, DatePicker, Upload } from 'antd';
import moment from 'moment';
import { DmsTab } from 'Components';
import { openNotice } from 'Utils';
const FormItem = Form.Item;

class StoreAdd extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      opts: [],
      detail: {},
      labelImgData: {
        uid: '',
        name: '',
        thumbUrl: ''
      }
    }
  }

  componentDidMount () {
    let cardId = this.props.params.cardId;
    if (cardId != 0) {
      /* 编辑 */
      this.setState({
        opts: ['编辑优惠券'],
        detail: {
          'name': '家装节部分商品满1000-100',
          'standardAmount': 1000,
          'derateAmount': 100,
          'issue': 20,
          'limitCount': 10,
          'effectStartDate': '2017-08-23',
          'effectEndDate': '2017-08-24',
          'explan': ''
        }
      });
    } else {
      this.setState({
        opts: ['新建优惠券'],
        detail: {}
      });
    }
  }

  cancelHandle () {
    hashHistory.goBack()
  }

  submitHandle () {
    const { validateFields, getFieldsValue } = this.props.form;

    validateFields((errors) => {//表单校验
      if (errors) {
        return
      }//表单校验有误，则不执行下面的代码
      const data = {
        ...getFieldsValue() //获取用户输入
      };
      // console.log(`你正在提交数据：${JSON.stringify(data)}`);
      openNotice('success', '保存成功', '');
      window.history.go(-1);
    });
  }

  updateAbbImg(result) {
    /* 略缩图更新 */
    if (result.fileList && result.fileList.length > 0) {
      this.setState({
        labelImgData: {
          ...this.state.labelImgData,
          uid: result.fileList[0].uid,
          name: result.fileList[0].name,
          thumbUrl: result.fileList[0].thumbUrl
        }
      });
    }
  }

  deleteAbbImg() {
    /* 删除略缩图 */
    this.setState({
      labelImgData: {
        ...this.state.labelImgData,
        uid: '',
        name: '',
        thumbUrl: ''
      }
    });
  }

  render () {
    const { opts, detail, labelImgData } = this.state;
    const { getFieldDecorator } = this.props.form;
    let self = this;
    const abbProps = {
      action: '',
      onRemove: self.deleteAbbImg.bind(self),
      onChange: self.updateAbbImg.bind(self),
      listType: 'picture',
      defaultFileList: [],
      className: 'upload-img-only'
    };
    return <div className="dms-body">
      <DmsTab options={opts} defaultKey={0}>
        <Button onClick={this.cancelHandle.bind(this)}>取消</Button>
        <Button type='primary' onClick={this.submitHandle.bind(this)}>保存</Button>
      </DmsTab>
      <div className="dms-table-box">
        <Form layout="horizontal">
          <Row gutter={16}>
            <Col className="gutter-row" span={24}>
              <div className="upload_add_pro" style={{marginBottom: '20px'}}>
                <Upload {...abbProps}>
                  <span className="ti"><font>*</font>标签图</span>
                  <Button style={{display: labelImgData.uid.length==0 ? 'inline-block': 'none'}}>选择图片文件</Button>
                  <span className="hint">建议图片大小 : 90x90px</span>
                </Upload>
              </div>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={24}>
              <FormItem label="优惠券名称：" hasFeedback>
                {getFieldDecorator('name', {
                  initialValue: (detail !== null && detail.name) ? detail.name : '',
                  rules: [
                    {
                      required: true,
                      message: '请输入优惠券名称'
                    },
                  ],
                })(<Input type="text" />)}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <FormItem label="达标金额：" hasFeedback>
                {getFieldDecorator('standardAmount', {
                  initialValue: (detail !== null && detail.standardAmount) ? detail.standardAmount : '',
                  rules: [
                    {
                      required: true,
                      message: '请输入达标金额'
                    },
                  ],
                })(<Input type="number" />)}
              </FormItem>
            </Col>
            <Col className="gutter-row" span={12}>
              <FormItem label="减免金额：" hasFeedback>
                {getFieldDecorator('derateAmount', {
                  initialValue: (detail !== null && detail.derateAmount) ? detail.derateAmount : '',
                  rules: [
                    {
                      required: true,
                      message: '请输入减免金额'
                    },
                  ],
                })(<Input type="number" />)}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <FormItem label="发行数量：" hasFeedback>
                {getFieldDecorator('issue', {
                  initialValue: (detail !== null && detail.issue) ? detail.issue : '',
                  rules: [
                    {
                      required: true,
                      message: '请输入发行数量'
                    },
                  ],
                })(<Input type="number" />)}
              </FormItem>
            </Col>
            <Col className="gutter-row" span={12}>
              <FormItem label="每人限领：" hasFeedback>
                {getFieldDecorator('limitCount', {
                  initialValue: (detail !== null && detail.limitCount) ? detail.limitCount : '',
                  rules: [
                    {
                      required: true,
                      message: '请输入每人限领数量'
                    },
                  ],
                })(<Input type="number" />)}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <FormItem label="生效日期：" hasFeedback>
                {getFieldDecorator('effectStartDate', {
                  initialValue: (detail !== null && detail.effectStartDate) ? moment(detail.effectStartDate, 'YYYY-MM-DD') : '',
                  rules: [
                    {
                      required: true,
                      message: '请选择生效日期'
                    },
                  ],
                })(<DatePicker style={{ width: '100%' }}/>)}
              </FormItem>
            </Col>
            <Col className="gutter-row" span={12}>
              <FormItem label="失效日期：" hasFeedback>
                {getFieldDecorator('effectEndDate', {
                  initialValue: (detail !== null && detail.effectEndDate) ? moment(detail.effectEndDate, 'YYYY-MM-DD') : '',
                  rules: [
                    {
                      required: true,
                      message: '请选择失效日期'
                    },
                  ],
                })(<DatePicker style={{ width: '100%' }}/>)}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={24}>
              <FormItem label="说明：" hasFeedback>
                {getFieldDecorator('explan', {
                  initialValue: (detail !== null && detail.explan) ? detail.explan : ''
                })(<Input.TextArea autosize={{ minRows: 2, maxRows: 6 }} />)}
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  }
}
export default Form.create()(StoreAdd)


// WEBPACK FOOTER //
// ./src/routes/card/add.js